var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61317 8.47562C1.52238 8.33186 1.47698 8.25998 1.45157 8.14911C1.43248 8.06583 1.43248 7.9345 1.45157 7.85122C1.47698 7.74035 1.52238 7.66847 1.61317 7.52471C2.36344 6.33672 4.59669 3.3335 8.00002 3.3335C11.4034 3.3335 13.6366 6.33672 14.3869 7.52471C14.4777 7.66847 14.5231 7.74035 14.5485 7.85122C14.5676 7.9345 14.5676 8.06583 14.5485 8.14911C14.5231 8.25998 14.4777 8.33186 14.3869 8.47562C13.6366 9.6636 11.4034 12.6668 8.00002 12.6668C4.59669 12.6668 2.36344 9.6636 1.61317 8.47562Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/IconEye.1348e930ead759f19e343e8f233d3bae.svg";
export { ForwardRef as ReactComponent };